import { defineStore } from 'pinia'
import ForgotPasswordStore, { ForgotPasswordState } from '@/modules/forgotPassword/types/store/ForgotPasswordStore'
import { RestorePasswordPaylaod } from '@/modules/forgotPassword/types/api/ForgotUserPassword'
import LoginApi from '@/modules/auth/service'
import { LoginDataI } from '@/modules/auth/types/store/UserStoreI'
import { TokenManager } from '@/entities/security/TokenManager'
import UserToken from '@/entities/security/UserToken'

const loginApi = new LoginApi()
const tokenManager = new TokenManager()

export const useForgotPasswordStore: ForgotPasswordStore = defineStore('forgotPassword', {
  state: () =>
    ({
      email: '',
    }) as ForgotPasswordState,
  getters: {},
  actions: {
    async restoreUserPassword(data) {
      const response = await this.$services.forgotPassword.resetUserPassword(data)
      if (response instanceof Error) {
        return response
      }
    },
    async checkIsTokenValid(token: string): Promise<boolean> {
      return await this.$services.forgotPassword.checkIsTokenValid(token)
    },
    async updatePasswordWithToken(payload: RestorePasswordPaylaod) {
      const response = await this.$services.forgotPassword.updatePasswordWithToken(payload)
      if (response.email) {
        this.email = response.email
      }
    },
    async login(payload: LoginDataI) {
      const response = await loginApi.postLogin(payload)
      if (response.status === 200) {
        tokenManager.createUserAccess(new UserToken(response.headers.bearer))
      }
    },
  },
})
